import React, { useState, useEffect, useContext } from "react";
import DimLoader from "../../../../../../templates/components/DimLoader";
import ModalBox from "../../../../../../templates/components/ModalBox";
// import AddSoapNotesForm from "../../../../soapNotes/add-soapNotes-form/AddSoapNotesForm";
import { store } from "../../../../../../../context/StateProvider";
import SoapNotesService from "../../../../../../../services/api/soapnotes.service";
import SoapNotesTable from "../../../patient-soap-notes/SoapNotesTable";
import SoapNotesAdd from "../../../patient-soap-notes/soap-notes-add/SoapNotesAdd";

const SoapNotesList = (props) => {
  const [soapNotesList, setSoapNotesList] = useState();
  const [showAdd, setShowAdd] = useState(false)
  const [isLoader, setIsLoader] = useState(true)
  const globalStateAndDispatch = useContext(store);
  const contextState = globalStateAndDispatch.state;
  useEffect(() => {
    pullSoapNotesList();
  }, [])

  const pullSoapNotesList = () => {
    setIsLoader(true)
    let reqObj = {}
    reqObj.SortField = 'createdOn'
    reqObj.Asc = false
    reqObj.PracticeLocationId = contextState.practiceLocationId
    reqObj.PatientId = props.patientId
    return SoapNotesService.findSoapNotes(reqObj)
      .then((res) => {
        if (res?.data?.length == 0) {
          setSoapNotesList()
        } else {
          setSoapNotesList(res.data);
        }
      })
      .catch((err) => {
        setSoapNotesList()
      }).finally(() => {
        setIsLoader(false)
      })
  };
  return (
    <div>
      {isLoader ? (
        <div className="row d-flex g-4 justify-content-between p-3">
          <DimLoader />
        </div>
      ) : soapNotesList != null ? (
        <div className="row d-flex g-4 justify-content-between p-3">
          <SoapNotesTable loading={isLoader} soapNotes={soapNotesList} refresh={() => { setSoapNotesList(); pullSoapNotesList() }} />
        </div>
      ) : (
        <div className="ui warning message mt-3 segment p-3 shadow-sm">
          <span>
            There are currently no Soap Notes for this user.{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowAdd(true);
              }}
            >
              Add Soap Notes
            </a>
          </span>
        </div>
      )}
      <ModalBox open={showAdd} onClose={() => setShowAdd(false)} title="Add Soap Notes">
        <SoapNotesAdd patientId={props.patientId} onClose={() => { setShowAdd(false) }} refresh={() => pullSoapNotesList()} />
      </ModalBox>
    </div>
  );
};

export default SoapNotesList;